var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ConfigProvider',{attrs:{"locale":_vm.zh_CN}},[_c('Main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }